import React from 'react';

import { Card } from '@iwoca/orion';

import { CopyLandingLink } from './CopyLandingLink/SpendingLimitLandingLink';
import PersonIcon from '../../../../assets/PersonIcon.png';
import { MAX_AMOUNT_PAY_LATER } from '../../../../Buyer/PayLinkLanding/PaymentDetails/PaymentDetails';
import { TickIcon } from '../../../../components/svg/TickIcon';
import { displayCurrency } from '../../../../utils/DisplayCurrency';

const BenefitItem = ({ children }: { children: React.ReactNode }) => {
  return (
    <li className="mt-s flex">
      <span className="mr-m inline-block overflow-visible align-middle">
        <TickIcon
          title="Approved application tick"
          className="mt-2xs h-[1rem] w-[1rem]"
        />
      </span>
      <p className="m-0 text-m font-bold">{children}</p>
    </li>
  );
};

export const SpendingLimitBanner = () => {
  const maxAmountText = displayCurrency(MAX_AMOUNT_PAY_LATER, 0);

  return (
    <Card className="mb-2xl !bg-secondary-95 !p-0 text-m font-reg">
      <div className="flex flex-col gap-l p-xl text-left m800:flex-row m800:items-start">
        <div>
          <img
            src={PersonIcon}
            className="block h-[64px] w-[64px]"
            alt="Person icon"
          />
        </div>
        <div>
          <div className="mb-l text-l font-bold text-primary-10">
            Give your trade customers a spending limit up to {maxAmountText}
          </div>
          <div className="mb-m font-reg">
            Now your trade customers can access their spending limit before they
            are at the checkout with their iwocaPay Account.
          </div>
          <ul className="m-0 inline-block list-none justify-center p-0 align-middle">
            <BenefitItem>
              Outsource risk, admin and checks to the experts (us)
            </BenefitItem>
            <BenefitItem>
              Increase average order value and customer loyalty
            </BenefitItem>
            <BenefitItem>
              Slicker checkout experience for new and existing customers
            </BenefitItem>
          </ul>
          <CopyLandingLink />
        </div>
      </div>
    </Card>
  );
};
